module.exports = __webpack_public_path__ + "static/image/promotion-p3.svg?af4c969e9fc3d348fca8409ac5ff0df1";